import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpHeaders,
    HttpInterceptor, HttpResponse
} from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import * as moment from 'moment';
import { catchError, tap } from 'rxjs/operators';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AuthenticationService } from "../services/utils/authentication.service";
import { StorageService } from 'front-common-toolkits';
import { Store } from "@ngrx/store";
import { AppState } from "src/app/services/state/app.state";
import * as UserActions from "src/app/services/state/actions/user.action";
import { promise } from 'protractor';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private cookieService: CookieService,
        private storageService: StorageService,
        private authenticationService: AuthenticationService,
        private notification: NzNotificationService,
        private store: Store<AppState>
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return from(this.handle(request, next))

    }
    async handle(request: HttpRequest<any>, next: HttpHandler) {
        const token = this.getToken();
        const businessType = this.getBusinessType();
        const header = {};


        // 保留原先header里的内容
        const headerKeys = request.headers.keys();
        headerKeys.forEach(key => {
            header[key] = request.headers.get(key);
        });

        if (businessType !== null) {
            header['businessType'] = businessType;
        }
        if (request.url.includes('/services/auth/refresh_token')) {
            header['x-access-token'] = token;
        }
        if (token && !(request.method === 'POST' && (request.url.includes('/services/auth/login') ||
            request.url.includes('/ten/auth/user/tenant/login')))) { // 登录事件排除在外
            // header['authorization'] = 'Bearer ' + token;
            header['x-access-token'] = token;
        }
        const authReq = request.clone({
            headers: new HttpHeaders(header)
        });

        const authTime = this.cookieService.get('authTime');
        const accessTokenExpireMinutes = this.storageService.getLocalItem('accessTokenExpireMinutes');
        //去递归 
        if (!request.url.includes('/auth/user/refresh_token') && !request.url.includes('/auth/refresh_token')) {
            if (authTime && accessTokenExpireMinutes) {
                const timeDiff = moment().diff(moment(authTime), 'm');
                // console.log('header没刷新', header)
                // console.log('这是比较条件 ',timeDiff >= (accessTokenExpireMinutes > 1 ? accessTokenExpireMinutes -1 : 1))
                if (timeDiff >= accessTokenExpireMinutes - 5) {
                    // if (timeDiff >= (accessTokenExpireMinutes > 1 ? accessTokenExpireMinutes - 1: 1)) {
                    console.log('header未调用', header)
                    await this.authenticationService.refreshToken()
                    const token = this.getToken();
                    header['x-access-token'] = token;
                    console.log('header刷新', header)
                }
            }
        }
        if (request.url.includes('/auth/user/refresh_token')) {
            return next.handle(authReq).pipe(
                tap((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        this.cookieService.set('tokenCheck', '1', moment().add(30, 'd').toDate());
                    }
                }),
                catchError((error: any) => {
                    console.log('authReq', authReq)
                    console.log('token.intercptor 方法intercept 101', error)
                    console.log('token.intercptor 方法intercept 101', this.cookieService.get('token'))
                    if (error.status === 401) {
                        this.notification.error('登录失效', '登录失效，请重新登录');
                        this.store.dispatch(new UserActions.Logout());
                        this.router.navigateByUrl('/login');
                    }
                    return throwError(error);
                })
            ).toPromise();
        } else {
            return next.handle(authReq).pipe(
                tap(event => {
                    if (event instanceof HttpResponse) {
                        if (event.body && event.body.code !== 0) {
                            if (event.body.code === -2) {
                                console.log('authReq', authReq)
                                console.log('token.intercptor 方法intercept 的next.handle 102', event)
                                console.log('token.intercptor 方法intercept 的next.handle 102', this.cookieService.get('token'))

                                this.notification.create('error', '登录信息过期或无效', '请重新登录!');
                                this.cookieService.delete('tenantLoginResult');
                                this.store.dispatch(new UserActions.RemoveUser())
                                this.router.navigate(['/login']);
                                return;
                            }
                            if (event.body.message) {
                                console.log('authReq', authReq)
                                console.log('token.intercptor 方法intercept 的event.body.message 103', event)
                                console.log('token.intercptor 方法intercept 的event.body.message 103', this.cookieService.get('token'))
                                this.notification.create('error', event.body.message, '');
                            }
                        }
                    }
                }),
                catchError((error: any) => {
                    console.log('authReq', authReq)
                    console.log('next.handle(authReq)  104', error)
                    console.log('next.handle(authReq)  104', this.cookieService.get('token'))
                    if (request.url.includes('assets/columnSettings')){
                        return;
                    }
                    if (error.status === 500) {
                        this.notification.create('error', error.message, error.error.message);
                    }
                    if (error.status === 401 && !request.url.includes('/login')) {
                        this.notification.create('error', '登录信息过期', '请重新登录!');
                        this.store.dispatch(new UserActions.RemoveUser())
                        this.router.navigate(['/login']);
                    }
                    if (error.status === 400) {
                        this.notification.create('error', error.message, error.error.message);
                    }
                    if (error.status === 404) {
                        this.notification.create('error', error.message, error.error.message);
                    }
                    return throwError(error);
                })
            ).toPromise();
        }
    }





    //无感刷新token
    getToken(): string {
        const tokenCheck = this.cookieService.get('tokenCheck');
        if (tokenCheck && tokenCheck !== '') {
            // this.tokenRefresh();
            // this.cookieService.set('tokenCheck', '1', moment().add(30, 'm').toDate());
            return this.cookieService.get('token');
        } else {
            // if (window['logoutTimmer']) {
            //     clearTimeout(window['logoutTimmer'])
            // } else{
            //     window['logoutTimmer'] = setTimeout(() => {
            //         this.authenticationService.logOut().subscribe(res => {
            //             this.storageService.clearUserInfo();
            //         })
            //     }, 500);
            // }
            return '';
        }
    }

    getBusinessType(): string {
        const businessType = this.storageService.getBusinessTypeItem();
        if (businessType) {
            return businessType.toString();
        } else {
            return null;
        }
    }

    tokenDelete() {
        if (window['logoutTimmer']) {
            clearTimeout(window['logoutTimmer'])
        } else {
            window['logoutTimmer'] = setTimeout(() => {
                this.authenticationService.logOut().subscribe(res => {
                    this.storageService.clearUserInfo();
                })
            }, 500);
        }
    }


}
